import MessageItem from "./MessageItem";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { formatDateLabel } from "../../utils/pip";

const MessageList = ({ userId }) => {
  const scrollRef = useRef(null);
  const { messages, messagesLoading } = useSelector((s) => s.chat.chat);
  const groupedMessages = messages.reduce((acc, msg) => {
    const dateKey = formatDateLabel(msg.created_at);
    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(msg);
    return acc;
  }, {});
  useEffect(() => {
    const el = scrollRef.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, [messages]);
  const Loader = ({ size = 40 }) => {
    return <div className="ct_loader" style={{ width: size, height: size }} />;
  };

  // export default Loader;

  if (messagesLoading) {
    return (
      <div class="modal-body">
        <div
          class="msg-body ct_custom_scroll"
          style={{
            scrollBehavior: "auto",
            paddingBottom: "80px",
          }}
        >
          <div className="ct_chat_loader_center">
            <Loader size={50} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div class="modal-body">
      <div
        class="msg-body ct_custom_scroll"
        style={{
          scrollBehavior: "auto",
          paddingBottom: "80px",
        }}
        ref={scrollRef}
      >
        {/* {messagesLoading && (
          <div className="ct_chat_loader_center">
          <Loader size={50} />
          </div>
        )} */}
        <ul className={messages?.length > 0 ? "d-block" : "d-none"}>
          {Object.entries(groupedMessages).map(([date, msgs]) => (
            <div key={date}>
              {/* 🔹 DATE SEPARATOR */}
              <div className="ct_chat_date text-center mt-4">
                <span>{date}</span>
              </div>

              {msgs.map((msg, i) => (
                <MessageItem
                  key={i}
                  msg={msg}
                  isOwn={msg.sender_id == userId}
                />
              ))}
            </div>
          ))}
        </ul>

        <div
          className={`ct_not_chat_here ${messages?.length > 0 ? "d-none" : "d-block"}`}
        >
          <i class="fa-regular fa-message ct_fs_28 text-center mx-auto"></i>
          <h4 className="mt-2">No Message Yet</h4>
          <p className="mb-0">Start a conversion to see your message</p>
        </div>
      </div>
    </div>
  );
};

export default MessageList;
